import React from 'react';
import { useForm } from 'react-hook-form';

interface CheckboxProps {
  id?: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  className?: string;
  readonly?: boolean;
  disabled?: boolean;
  name: string;
  required?: boolean;
  value?: string;
  data?: any[];
}

function Checkbox({
  id,
  checked,
  label,
  readonly,
  className,
  name,
  value,
  data,
}: CheckboxProps) {
  const defaultId = React.useMemo(() => Math.random().toString(), []);
  const defaultChecked = checked ? checked : false;
  const [isChecked] = React.useState(defaultChecked);

  const { register } = useForm({ defaultValues: { name: data } });

  return (
    <div
      className={`${className ? className : ''} ${
        isChecked ? 'bg-secondary-100/50' : 'bg-white'
      } w-100 border m-2 shadow-button border-secondary-100 bg-white rounded-lg p-4 hover:bg-primary-200/10`}
    >
      <label>
        <input
          type="checkbox"
          id={id ? id : defaultId}
          checked={isChecked}
          readOnly={readonly}
          disabled={isChecked}
          value={value}
          className="w-8 h-8 cursor-pointer rounded-full border-tertiary-100 hover:border-checked/50 bg-tertiary-200 text-checked hover:bg-checked/50 focus:ring-checked"
          {...register(name as 'name', {})}
        />
        <span className="mx-4 tracking-widest text-black text-sm">{label}</span>
      </label>
    </div>
  );
}

export default Checkbox;
